import api from "./core";

const basePath = "api/{{serverSegment}}/Collections";

export default {
  get(id) {
    return api.get(`${basePath}/Find/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query() {
    return api.get(`${basePath}/AllNames`);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
